import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation, Link } from "react-router-dom";
import Homescreen from "./screen/Homescreen";
import AboutScreen from "./screen/AboutScreen";
import NavBar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";

function ScrollPosition() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      let target = hash.slice(1);
      try { target = decodeURIComponent(target); } catch { /* Keep malformed fragments harmless. */ }
      document.getElementById(target)?.scrollIntoView();
    } else window.scrollTo({ top: 0 });
  }, [pathname, hash]);
  return null;
}
function InventoryPage() {
  return <><NavBar /><main id="main-content" className="tb-route-page" tabIndex="-1"><div className="tb-container"><p className="tb-eyebrow">BILAR I LAGER</p><h1>Hitta din nästa bil<br />hos Touza Bilar.</h1><p>Vårt aktuella utbud finns på Blocket. Där hittar du bilarnas bilder, specifikationer och priser.</p><div className="tb-actions"><a className="tb-button tb-button-primary" href="https://www.blocket.se/butik/touza-bilar">Se aktuella bilar på Blocket ↗</a><a className="tb-button tb-button-outline" href="tel:+46855066158">Ring oss</a></div></div></main><Footer /></>;
}
function NotFound() {
  return <><NavBar /><main id="main-content" className="tb-route-page" tabIndex="-1"><div className="tb-container"><p className="tb-eyebrow">404</p><h1>Här var det tomt.</h1><p>Sidan du letar efter finns inte. Vi hjälper dig gärna vidare.</p><Link className="tb-button tb-button-primary" to="/">Till startsidan →</Link></div></main><Footer /></>;
}
function App() {
  return <div className="App"><BrowserRouter><ScrollPosition /><Routes>
    <Route path="/" element={<Homescreen />} />
    <Route path="/about" element={<AboutScreen />} />
    <Route path="/cars" element={<InventoryPage />} />
    <Route path="/cardetail" element={<Navigate to="/cars" replace />} />
    <Route path="/blog" element={<Navigate to="/" replace />} />
    <Route path="/blogview" element={<Navigate to="/" replace />} />
    <Route path="*" element={<NotFound />} />
  </Routes></BrowserRouter></div>;
}
export default App;
